import { HubConnectionBuilder } from '@microsoft/signalr';
import { useState, useEffect, useContext } from "react";
import config from "config.js";
import GlobalContext from "context/globalContext";

export default function useSignalR(sessionId, connectionType) {
    const [hubConnection, setHubConnection] = useState(null);
    const globalContext = useContext(GlobalContext);

    useEffect(() => {
        let connection = new HubConnectionBuilder()
            .withUrl(config.signalRServerUrl)
            .withAutomaticReconnect()
            .build();

        setHubConnection(connection);
        connection.start()
            .then(() => {
                connection.invoke('setConnected', sessionId, connectionType);
                globalContext.session.setSignalRConnected(true);
            })
            .catch((err) => console.log("Error while establishing connection ", err));
    // eslint-disable-next-line
    }, []);

    return hubConnection;
}
